export default "__VITE_ASSET__2b1395fa__"